export default {
  id: 'funding-obligations',
  title: 'Funding Obligations (Cost-Plus)',
  category: 'Admin',
  summary: 'Capture customer funding as contract obligations, then attribute Labor and Fee amounts to project funding line items on cost-plus primes.',
  overview: 'On cost-based (cost-plus) prime contracts, funding is managed in two places: Contract Funding obligations on the contract, and the Obligation Funding panel on the project. Obligations (CLIN/SLIN/ACRN, cost element, work type, and amount) define what the customer funded. Project Labor and Fee line items consume that funding so invoicing and burn tracking stay aligned.',
  howItWorks: [
    'Set up Fee Basis and Direct Labor Rates on the cost-based contract first — project pairs and breakouts depend on them.',
    'On Contract Details → Contract Funding, add or bulk-import obligations tied to a task order / option year with CLIN, SLIN, ACRN, cost element, work type, funding basis, and obligated amount.',
    'On a prime cost-plus project, Customer Funding Lines show those obligations with obligated, allocated, and available amounts.',
    'Manage line item breakout to split an obligation into hours/amounts by fee basis when funding basis is Contract Rates for Labor or Fixed Fee.',
    'Manage line item charges (attribution) to assign funded hours/amounts from obligations onto project Labor/Fee funding lines.',
    'Add Labor + Fee Pair creates paired project lines for an employee and charge code using fee-basis rates and funded hours.',
    'Balance Hours scales funded hours so funded dollars match customer funding for a fee-basis group.',
    'Mismatch warnings appear when breakout totals do not match obligated amounts, or available funding does not match remaining capacity — resolve them before invoicing.'
  ],
  actions: [
    {
      name: 'Add Funding Line (contract)',
      description: 'Creates a funding obligation on the contract for a task order / option year. It then appears on the linked project’s Customer Funding Lines.'
    },
    {
      name: 'Bulk Import (contract)',
      description: 'Uploads an Excel template of obligations. Import is all-or-nothing: if any row fails validation, nothing is imported. A result modal lists successes or errors.'
    },
    {
      name: 'Manage line item breakout',
      description: 'Defines how an obligation’s dollars break into fee-basis hours/amounts so the breakout total matches the obligated amount.'
    },
    {
      name: 'Manage line item charges',
      description: 'Attributes funded hours/amounts from an obligation onto project funding lines. Remaining obligation capacity is enforced.'
    },
    {
      name: 'Add Labor + Fee Pair',
      description: 'Creates paired Labor and Fee project funding lines for a charge code and user, using Direct Labor Rates and Fee Basis.'
    },
    {
      name: 'Balance Hours',
      description: 'Adjusts funded hours across a fee-basis group so funded dollars match the customer funding allocation.'
    },
    {
      name: 'Split Combined Lines into Labor + Fee',
      description: 'One-time migration for legacy combined funding lines. Splits them into separate Labor and Fee components.'
    },
    {
      name: 'Reassign / clean up unassociated lines',
      description: 'Moves or resolves funding lines that are not correctly tied to obligations so allocations stay accurate.'
    }
  ],
  tips: [
    'Create Fee Basis and Direct Labor Rates before adding Labor + Fee pairs.',
    'Add obligations on the contract before expecting data in the project Obligation Funding panel.',
    'Resolve mismatch icons (breakout ≠ obligated, or available ≠ remaining) before creating cost-plus invoices.',
    'Funding basis (Actuals vs Contract Rates) changes how breakout and rates are applied — pick the basis that matches how you bill.'
  ],
  related: ['contracts', 'projects', 'invoices']
};



// WEBPACK FOOTER //
// ./client/help/content/funding-obligations.js